var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgRejectButtonIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.84214L9.40232 2.74269L9.61469 3.0305L9.95566 2.92248L12.2073 2.20917L12.2247 4.57102L12.2273 4.92868L12.5667 5.04171L14.8075 5.7881L13.4333 7.70909L13.2252 8L13.4333 8.29091L14.8075 10.2119L12.5667 10.9583L12.2273 11.0713L12.2247 11.429L12.2073 13.7908L9.95566 13.0775L9.61469 12.9695L9.40232 13.2573L8 15.1579L6.59767 13.2573L6.38531 12.9695L6.04434 13.0775L3.79272 13.7908L3.77533 11.429L3.77269 11.0713L3.43335 10.9583L1.19247 10.2119L2.56666 8.29091L2.77476 8L2.56666 7.70909L1.19247 5.7881L3.43335 5.04171L3.77269 4.92868L3.77533 4.57102L3.79272 2.20917L6.04434 2.92248L6.38531 3.0305L6.59767 2.74269L8 0.84214Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.705 8L10.5 6.205L9.795 5.5L8 7.295L6.205 5.5L5.5 6.205L7.295 8L5.5 9.795L6.205 10.5L8 8.705L9.795 10.5L10.5 9.795L8.705 8Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgRejectButtonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reject_button_icon.6e92f1ace888dd02bdd7d55f6004b975.svg";